import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

function LetterOpen(props) {
  const orange = getColorValue('illustrationOrange');
  const blue = getColorValue('illustrationAccent');
  const paperColor = getColorValue('illustrationPaper');
  const innerPaperColor = getColorValue('illustrationInnerPaper');
  const lineColor = getColorValue('illustrationLine');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path d="m137.33 58.999-85.33 71.36v86.19h170.66v-86.19z" fill={blue} />
      <path d="m202.51 86.1885h-130.3596v130.3595h130.3596z" fill={orange} />
      <path
        d="m169.84 86.1885h-65.03l-32.6596 27.3195v103.04h130.3596v-103.04z"
        fill={getColorValue('tealDark')}
      />
      <path
        d="m191.81 96.8789h-108.9702v108.9701h108.9702z"
        fill={paperColor}
      />
      <g fill={orange}>
        <path d="m181.48 108.528h-86.3599v4h86.3599z" />
        <path d="m181.48 124.639h-86.3599v4h86.3599z" />
        <path d="m181.48 140.759h-86.3599v4h86.3599z" />
        <path d="m181.48 156.868h-86.3599v4h86.3599z" />
        <path d="m181.48 172.988h-86.3599v4h86.3599z" />
        <path d="m181.48 189.099h-86.3599v4h86.3599z" />
      </g>
      <path d="m154.76 216.549-102.5803-86.17.17 86.17z" fill={blue} />
      <path d="m119.891 216.549 102.58-86.17-.16 86.17z" fill={blue} />
      <path
        d="m119.891 216.548h34.87l-17.43-14.65z"
        fill={illustrationColors.staticDarkBlue}
      />
      {/* Layered envelope for depth */}
      <path d="m137.33 58.999-85.33 71.36v86.19h170.66v-86.19z" fill={blue} />
      <path d="m202.51 86.1885h-130.3596v130.3595h130.3596z" fill={orange} />
      <path
        d="m169.84 86.1885h-65.03l-32.6596 27.3195v103.04h130.3596v-103.04z"
        fill={getColorValue('tealDark')}
      />
      <path
        d="m191.81 96.8789h-108.9702v108.9701h108.9702z"
        fill={innerPaperColor}
      />
      <path
        d="m164.386 176.252c1.5-.1 1.51-1.22.01-1.35-2.13-.18-4.36-.29-7.23-.32-3.26.03-4.07.25-6.28.21-3.73-.03-10.02-.39-11.53-.48-.22-.01-.45-.02-.67-.01-1.61.03-8.65.14-14.72.01-4.28-.03-6.93-.05-8.32-.06-3.27-.02-5.72.08-8.12.27-1.32.11-1.33 1.08 0 1.2 2.4.23 4.84.37 8.11.4 1.27.01 3.92.3 7.65.38.61.01 1.22 0 1.82-.04 5.21-.32 11.98-.16 11.98-.16s10.1.09 14.36.12c3.21.02 4.75.03 5.7.04 2.87.02 5.11-.05 7.24-.2z"
        fill={lineColor}
      />
      <path
        d="m171.536 115.56c1.86-.1 1.86-1.22 0-1.35-2.63-.18-5.39-.29-8.95-.32-4.03.03-5.03.25-7.76.21-4.61-.03-12.39-.39-14.26-.48-.28-.01-.55-.02-.83-.01-1.99.03-10.7.14-18.19.01-5.3-.03-8.57-.05-10.29-.06-4.04-.02-7.07.08-10.03.27-1.6297.11-1.6397 1.08 0 1.2 2.96.23 5.99.37 10.03.4 1.57.01 4.84.3 9.46.38.75.01 1.51 0 2.25-.04 6.45-.32 14.81-.16 14.81-.16s12.48.09 17.75.12c3.97.02 5.88.03 7.05.04 3.55.02 6.32-.05 8.95-.2z"
        fill={lineColor}
      />
      <path
        d="m171.536 135.791c1.86-.1 1.86-1.22 0-1.35-2.63-.18-5.39-.29-8.95-.32-4.03.03-5.03.25-7.76.21-4.61-.03-12.39-.39-14.26-.48-.28-.01-.55-.02-.83-.01-1.99.03-10.7.14-18.19.01-5.3-.03-8.57-.05-10.29-.06-4.04-.02-7.07.08-10.03.27-1.6297.11-1.6397 1.08 0 1.2 2.96.23 5.99.37 10.03.4 1.57.01 4.84.3 9.46.38.75.01 1.51 0 2.25-.04 6.45-.32 14.81-.16 14.81-.16s12.48.09 17.75.12c3.97.02 5.88.03 7.05.04 3.55.02 6.32-.05 8.95-.2z"
        fill={lineColor}
      />
      <path
        d="m171.536 156.021c1.86-.1 1.86-1.22 0-1.35-2.63-.18-5.39-.29-8.95-.32-4.03.03-5.03.25-7.76.21-4.61-.03-12.39-.39-14.26-.48-.28-.01-.55-.02-.83-.01-1.99.03-10.7.14-18.19.01-5.3-.03-8.57-.05-10.29-.06-4.04-.02-7.07.08-10.03.27-1.6297.11-1.6397 1.08 0 1.2 2.96.23 5.99.37 10.03.4 1.57.01 4.84.3 9.46.38.75.01 1.51 0 2.25-.04 6.45-.32 14.81-.16 14.81-.16s12.48.09 17.75.12c3.97.02 5.88.03 7.05.04 3.55.02 6.32-.05 8.95-.2z"
        fill={lineColor}
      />
      <path d="m154.76 216.549-102.5803-86.17.17 86.17z" fill={blue} />
      <path d="m119.891 216.549 102.58-86.17-.16 86.17z" fill={blue} />
      <path
        d="m119.891 216.548h34.87l-17.43-14.65z"
        fill={illustrationColors.staticDarkBlue}
      />
    </svg>
  );
}

export default LetterOpen;
